/**
 *  Created by piotr@revisual.io on 15/08/2025
 */
import { orderQuotas } from "../../helpers/subscription";
import { useCurrentOrganizationStore } from "../../../../hooks/redux/currentOrganization";
import { hasSubscription } from "../../helpers/organization";
import PricingComparisonTableItem from "./PlanComparisonTableItem";
import { QUOTAS, UsageFieldsMapping } from "../../../../consts";
import { useCallback } from "react";

/**
 *
 * @param {Object} newPlan
 * @param {Object} newPrice
 * @param {function} onCancel
 * @param {function} onSubmit
 * @returns {JSX.Element}
 * @constructor
 */
export const PlanComparisonTable = ({
  newPlan,
  newPrice,
  onCancel,
  onSubmit,
}) => {
  const { currentOrganization } = useCurrentOrganizationStore();
  const subscription = hasSubscription(currentOrganization);

  const quotas = subscription.quotas;

  const _onSubmit = useCallback(
    (e) => {
      onSubmit(newPlan, newPrice);
    },
    [newPlan, newPrice, onSubmit]
  );

  const orderedQuotas = orderQuotas(
    quotas,
    currentOrganization.model.usage
  ).map((key, idx) => {
    const usage = currentOrganization.model.usage[UsageFieldsMapping[key]];
    if (
      [
        QUOTAS.widgets,
        QUOTAS.team,
        QUOTAS.integrations,
        QUOTAS.domains,
      ].includes(key) &&
      newPlan.metadata[key] >= usage
    ) {
      return;
    }
    return (
      <li key={`quota-${idx}`}>
        <PricingComparisonTableItem
          quotaKey={key}
          quota={quotas[key]}
          newQuota={newPlan.metadata[key]}
          usage={usage}
        />
      </li>
    );
  });

  return (
    <div className={"card-box"}>
      <div className={"card-title d-flex justify-content-between"}>
        <span>You can't downgrade just yet</span>
      </div>
      <div>
        <div className={"container"}>
          <div className={"row"}>
            <div className={"col-md-6"}>
              <p>
                You’re trying to switch from the{" "}
                <strong>{subscription.name}</strong> to the{" "}
                <strong>{newPlan.name}</strong>, but your current usage is above
                the limits of the new plan.
              </p>
              <p>
                The table below shows where your usage exceeds the limits. To
                downgrade, you'll need to:
              </p>
              <ul className={"list"}>
                <li>
                  <strong>Unpublish widgets</strong> until you’re within the new
                  plan's limits
                </li>

                <li>
                  <strong>Remove extra team members</strong> if you're above the
                  limit
                </li>

                <li>
                  <strong>Disconnect or reduce integrations</strong> if
                  necessary
                </li>

                <li>
                  <strong>Lower other usage areas</strong> highlighted in red or
                  with warnings
                </li>
              </ul>
              <p>
                Once your usage matches the new plan's limits, you’ll be able to
                downgrade successfully.
              </p>
            </div>
            <div className={"col-md-6"}>
              <div className={""}>
                <ul className={"list-unstyled "}>{orderedQuotas}</ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <hr />
      <div className={"w-100 d-flex justify-content-between"}>
        <button className={"btn btn-secondary"} onClick={onCancel}>
          Cancel
        </button>
        {/*<button className={"btn btn-warning"} onClick={_onSubmit}>
          Downgrade my plan
        </button>*/}
      </div>
    </div>
  );
};

export default PlanComparisonTable;
